export const MFE_ENVIRONMENTS = {
	auth: process.env.NEXT_PUBLIC_RVLIFE_AUTH_REMOTE_URL!,
	garage: process.env.NEXT_PUBLIC_RVLIFE_GARAGE_REMOTE_URL!,
	settings: process.env.NEXT_PUBLIC_RVLIFE_SETTINGS_REMOTE_URL!
} as const;

export const IS_DEVTOOLS_ENABLED = process.env.NEXT_PUBLIC_ENABLE_DEVTOOLS === 'true';
